import { PartialMessage } from '@bufbuild/protobuf'
import { HeaderImageStyle } from '@fingertip/creator-proto/gen/fingertip/common/enum/v1/header_image_style_pb'
import { Media } from '@fingertip/creator-proto/gen/fingertip/common/type/v1/media_pb'
import { Page } from '@fingertip/creator-proto/gen/fingertip/common/type/v1/page_pb'
import { createElement, memo, ReactNode } from 'react'

import { getLuminance } from '@/components/page-header/page-header-utils'

import { BasePageHeader } from './styles/base'
import { Basic1PageHeader } from './styles/basic-1'
import { Basic2PageHeader } from './styles/basic-2'
import { Basic3PageHeader } from './styles/basic-3'
import { Basic4PageHeader } from './styles/basic-4'
import { BigHeroPageHeader } from './styles/big-hero'
import { BigLogoPageHeader } from './styles/big-logo'
import { GeexAccountantPageHeader } from './styles/geex-accountant'
import { GeexActorPageHeader } from './styles/geex-actor'
import { GeexArchitectPageHeader } from './styles/geex-architect'
import { GeexArtGalleryPageHeader } from './styles/geex-art-gallery'
import { GeexArtistPageHeader } from './styles/geex-artist'
import { GeexAuthorPageHeader } from './styles/geex-author'
import { GeexBabySitterPageHeader } from './styles/geex-baby-sitter'
import { GeexBarPageHeader } from './styles/geex-bar'
import { GeexBarberPageHeader } from './styles/geex-barber'
import { GeexBirthdayPageHeader } from './styles/geex-birthday'
import { GeexCharityPageHeader } from './styles/geex-charity'
import { GeexChefPageHeader } from './styles/geex-chef'
import { GeexClothingStorePageHeader } from './styles/geex-clothing-store'
import { GeexCreativeDesignerPageHeader } from './styles/geex-creative-designer'
import { GeexDaySpaPageHeader } from './styles/geex-day-spa'
import { GeexDjPageHeader } from './styles/geex-dj'
import { GeexDoctorPageHeader } from './styles/geex-doctor'
import { GeexDogWalkerPageHeader } from './styles/geex-dog-walker'
import { GeexElectricianPageHeader } from './styles/geex-electrician'
import { GeexFashionPageHeader } from './styles/geex-fashion'
import { GeexFloristPageHeader } from './styles/geex-florist'
import { GeexFoundersPageHeader } from './styles/geex-founders'
import { GeexGamerPageHeader } from './styles/geex-gamer'
import { GeexGardenerPageHeader } from './styles/geex-gardener'
import { GeexGroceryPageHeader } from './styles/geex-grocery'
import { GeexGymPageHeader } from './styles/geex-gym'
import { GeexHairStylistPageHeader } from './styles/geex-hair-stylist'
import { GeexHandymanPageHeader } from './styles/geex-handyman'
import { GeexInteriorDesignerPageHeader } from './styles/geex-interior-designer'
import { GeexMakeUpPageHeader } from './styles/geex-make-up'
import { GeexMasseusePageHeader } from './styles/geex-masseuse'
import { GeexMeditationPageHeader } from './styles/geex-meditation'
import { GeexMusicConcertPageHeader } from './styles/geex-music-concert'
import { GeexMusicianPageHeader } from './styles/geex-musician'
import { GeexNailSalonPageHeader } from './styles/geex-nail-salon'
import { GeexPersonalTrainerPageHeader } from './styles/geex-personal-trainer'
import { GeexPhotographerPageHeader } from './styles/geex-photographer'
import { GeexRealEstatePageHeader } from './styles/geex-real-estate'
import { GeexRestaurantPageHeader } from './styles/geex-restaurant'
import { GeexResumePageHeader } from './styles/geex-resume'
import { GeexSalesManagerPageHeader } from './styles/geex-sales-manager'
import { GeexSocialMediaPageHeader } from './styles/geex-social-media'
import { GeexSportsClubPageHeader } from './styles/geex-sports-club'
import { GeexTattooPageHeader } from './styles/geex-tattoo'
import { GeexTravelBloggerPageHeader } from './styles/geex-travel-blogger'
import { GeexTutorPageHeader } from './styles/geex-tutor'
import { GeexWebDesignerPageHeader } from './styles/geex-web-designer'
import { GeexWeddingPageHeader } from './styles/geex-weddding'
import { GeexYogaPageHeader } from './styles/geex-yoga'
import { InlinePageHeader } from './styles/inline'
import { OverlayPageHeader } from './styles/overlay'
import { TallPageHeader } from './styles/tall'

export type HeaderSlug = {
  id: string
  label: string
  showPrimaryLabel?: boolean
  showSecondaryLabel?: boolean
  skipShuffle?: boolean
  firstShuffle?: boolean
}

export const headerSlugs: HeaderSlug[] = [
  {
    id: 'GEEX_SOCIAL_MEDIA_LEFT',
    label: 'Nova',
    firstShuffle: true,
  },
  {
    id: 'GEEX_BABY_SITTER_LEFT',
    label: 'Mist',
    firstShuffle: true,
  },
  {
    id: 'GEEX_DOCTOR_LEFT',
    label: 'Lunar',
    showPrimaryLabel: true,
    firstShuffle: true,
  },
  {
    id: 'GEEX_BARBER_LEFT',
    label: 'Haze',
    showPrimaryLabel: true,
    firstShuffle: true,
  },
  {
    id: 'GEEX_CHEF_LEFT',
    label: 'Frost',
    showPrimaryLabel: true,
    firstShuffle: true,
  },
  {
    id: 'GEEX_FLORIST_LEFT',
    label: 'Bliss',
    showPrimaryLabel: true,
    firstShuffle: true,
  },
  {
    id: 'GEEX_GARDENER_LEFT',
    label: 'Flux',
    showPrimaryLabel: true,
    firstShuffle: true,
  },
  {
    id: 'GEEX_MEDITATION_LEFT',
    label: 'Vivid',
    showPrimaryLabel: true,
    firstShuffle: true,
  },
  {
    id: 'GEEX_HAIR_STYLIST_LEFT',
    label: 'Pulse',
    showPrimaryLabel: true,
    firstShuffle: true,
  },
  {
    id: 'GEEX_YOGA_LEFT',
    label: 'Fusion',
    showPrimaryLabel: true,
    firstShuffle: true,
  },
  { id: 'BASE_CENTER', label: 'Core', firstShuffle: true },
  { id: 'GEEX_ARCHITECT_LEFT', label: 'Ripple' },
  {
    id: 'GEEX_ART_GALLERY_LEFT',
    label: 'Prism',
    showPrimaryLabel: true,
  },
  {
    id: 'GEEX_ARTIST_LEFT',
    label: 'Breeze',
  },
  { id: 'GEEX_BAR_LEFT', label: 'Fern' },
  {
    id: 'GEEX_BIRTHDAY_LEFT',
    label: 'Ember',
  },
  {
    id: 'GEEX_CLOTHING_STORE_LEFT',
    label: 'Pebble',
    showPrimaryLabel: true,
    showSecondaryLabel: true,
  },
  {
    id: 'GEEX_CREATIVE_DESIGNER_LEFT',
    label: 'Quill',
  },
  {
    id: 'GEEX_DOG_WALKER_LEFT',
    label: 'Nimbus',
  },
  {
    id: 'GEEX_FASHION_LEFT',
    label: 'Sage',
    showPrimaryLabel: true,
  },

  {
    id: 'GEEX_FOUNDERS_LEFT',
    label: 'Zephyr',
    showPrimaryLabel: true,
  },
  {
    id: 'GEEX_GYM_LEFT',
    label: 'Marble',
    showPrimaryLabel: true,
    showSecondaryLabel: true,
  },
  {
    id: 'GEEX_HANDYMAN_LEFT',
    label: 'Slate',
    showPrimaryLabel: true,
  },
  {
    id: 'GEEX_INTERIOR_DESIGNER_LEFT',
    label: 'Echo',
    showPrimaryLabel: true,
  },
  { id: 'GEEX_MUSICIAN_LEFT', label: 'Lumen' },
  {
    id: 'GEEX_NAIL_SALON_LEFT',
    label: 'Vista',
    showPrimaryLabel: true,
  },
  {
    id: 'GEEX_PHOTOGRAPHER_LEFT',
    label: 'Verve',
  },
  {
    id: 'GEEX_REAL_ESTATE_LEFT',
    label: 'Zenith',
    showPrimaryLabel: true,
  },
  {
    id: 'GEEX_SALES_MANAGER_LEFT',
    label: 'Glide',
    showPrimaryLabel: true,
  },
  {
    id: 'GEEX_TATTOO_LEFT',
    label: 'Tidal',
    showPrimaryLabel: true,
    showSecondaryLabel: true,
  },
  {
    id: 'GEEX_TRAVEL_BLOGGER_LEFT',
    label: 'Rhythm',
    showPrimaryLabel: true,
  },
  { id: 'GEEX_TUTOR_LEFT', label: 'Flare' },
  { id: 'BASE_LEFT', label: 'Edge' },
  {
    id: 'BIG_LOGO_CENTER',
    label: 'Focus',
  },
  { id: 'TALL_LEFT', label: 'Rise' },
  { id: 'BASIC_1_LEFT', label: 'Nexus' },
  { id: 'BASIC_2_LEFT', label: 'Matrix' },
  { id: 'BASIC_3_LEFT', label: 'Mosaic' },
  { id: 'BASIC_4_LEFT', label: 'Sphere' },
  {
    id: 'GEEX_ACCOUNTANT_LEFT',
    label: 'Spark',
    showPrimaryLabel: true,
    skipShuffle: true,
  },
  {
    id: 'GEEX_ACTOR_LEFT',
    label: 'Whisper',
    showPrimaryLabel: true,
    skipShuffle: true,
  },
  {
    id: 'GEEX_AUTHOR_LEFT',
    label: 'Dusk',
    showPrimaryLabel: true,
    showSecondaryLabel: true,
    skipShuffle: true,
  },
  {
    id: 'GEEX_CHARITY_LEFT',
    label: 'Silk',
    showPrimaryLabel: true,
    skipShuffle: true,
  },
  {
    id: 'GEEX_DAY_SPA_LEFT',
    label: 'Drift',
    showPrimaryLabel: true,
    skipShuffle: true,
  },
  {
    id: 'GEEX_DJ_LEFT',
    label: 'Wisp',
    showPrimaryLabel: true,
    skipShuffle: true,
  },
  {
    id: 'GEEX_WEB_DESIGNER_LEFT',
    label: 'Cascade',
    showPrimaryLabel: true,
    skipShuffle: true,
  },
  {
    id: 'GEEX_WEDDING_LEFT',
    label: 'Orbit',
    showPrimaryLabel: true,
    skipShuffle: true,
  },
  {
    id: 'GEEX_RESTAURANT_LEFT',
    label: 'Quartz',
    showPrimaryLabel: true,
    skipShuffle: true,
  },
  {
    id: 'GEEX_PERSONAL_TRAINER_LEFT',
    label: 'Oasis',
    showPrimaryLabel: true,
    skipShuffle: true,
  },
  {
    id: 'GEEX_RESUME_LEFT',
    label: 'Neon',
    showPrimaryLabel: true,
    skipShuffle: true,
  },
  {
    id: 'GEEX_SPORTS_CLUB_LEFT',
    label: 'Vapor',
    showPrimaryLabel: true,
    skipShuffle: true,
  },
  {
    id: 'GEEX_MAKE_UP_LEFT',
    label: 'Aura',
    showPrimaryLabel: true,
    skipShuffle: true,
  },
  {
    id: 'GEEX_MASSEUSE_LEFT',
    label: 'Crest',
    showPrimaryLabel: true,
    skipShuffle: true,
  },
  {
    id: 'GEEX_GAMER_LEFT',
    label: 'Azure',
    showPrimaryLabel: true,
    skipShuffle: true,
  },
  {
    id: 'GEEX_ELECTRICIAN_LEFT',
    label: 'Pixel',
    showPrimaryLabel: true,
    showSecondaryLabel: true,
    skipShuffle: true,
  },
  {
    id: 'GEEX_MUSIC_CONCERT_LEFT',
    label: 'Halo',
    showPrimaryLabel: true,
    skipShuffle: true,
  },
]

type Props = {
  page?: PartialMessage<Page>
  headerSlug?: string
  headerImageStyle?: HeaderImageStyle | string
  children?: ReactNode
  isPreview?: boolean
  hasVerifiedBadge?: boolean
  forceMobile?: boolean
}

export const PageHeader = memo(
  ({
    page: oldPage,
    headerSlug = 'BASE_LEFT',
    headerImageStyle = HeaderImageStyle.DEFAULT,
    children,
    isPreview,
    hasVerifiedBadge,
    forceMobile,
  }: Props) => {
    const position: any = extractPosition(headerSlug)
    let bannerMedia: PartialMessage<Media> | undefined = oldPage?.bannerMedia
    let logoMedia: PartialMessage<Media> | undefined = oldPage?.logoMedia

    if (
      ['HEADER_IMAGE_STYLE_SWAP', HeaderImageStyle.SWAP].includes(
        headerImageStyle,
      )
    ) {
      bannerMedia = oldPage?.logoMedia
      logoMedia = oldPage?.bannerMedia
    } else if (
      ['HEADER_IMAGE_STYLE_BANNER', HeaderImageStyle.BANNER].includes(
        headerImageStyle,
      )
    ) {
      logoMedia = oldPage?.bannerMedia
      bannerMedia = undefined
    } else if (
      ['HEADER_IMAGE_STYLE_LOGO', HeaderImageStyle.LOGO].includes(
        headerImageStyle,
      )
    ) {
      logoMedia = oldPage?.logoMedia
      bannerMedia = undefined
    }

    const page = {
      ...oldPage,
      bannerMedia,
      logoMedia,
    }

    const hasBannerImage = !!page?.bannerMedia || isPreview
    const hasLogoImage = !!page?.logoMedia || isPreview
    const hasName = (!!page?.name && page.name.trim() !== '') || isPreview
    const hasDescription = !!page?.description || isPreview
    const hasIcons =
      (page?.socialIcons || []).filter((item) => !!item.url).length > 0 ||
      isPreview

    const bannerLuminance = getLuminance(page?.bannerMedia)

    const headerComponent = getHeaderComponent(headerSlug)

    if (
      !page?.bannerMedia &&
      !page?.logoMedia &&
      !page?.name &&
      !page?.description &&
      !isPreview
    ) {
      return children || <div className="h-fluid-4" />
    }

    return createElement(headerComponent, {
      page,
      isPreview,
      headerComponent,
      position,
      hasBannerImage,
      hasLogoImage,
      hasName,
      hasDescription,
      hasIcons,
      bannerLuminance,
      hasVerifiedBadge,
      forceMobile,
    })
  },
)

function getHeaderComponent(headerSlug: string): any {
  const segments = headerSlug.split('_')
  const result = segments.slice(0, -1).join('_')

  switch (result) {
    case 'OVERLAY':
      return OverlayPageHeader
    case 'TALL':
      return TallPageHeader
    case 'BIG_LOGO':
      return BigLogoPageHeader
    case 'INLINE':
      return InlinePageHeader
    case 'BIG_HERO':
      return BigHeroPageHeader
    case 'GEEX_ACCOUNTANT':
      return GeexAccountantPageHeader
    case 'GEEX_ACTOR':
      return GeexActorPageHeader
    case 'GEEX_ARCHITECT':
      return GeexArchitectPageHeader
    case 'GEEX_ART_GALLERY':
      return GeexArtGalleryPageHeader
    case 'GEEX_ARTIST':
      return GeexArtistPageHeader
    case 'GEEX_AUTHOR':
      return GeexAuthorPageHeader
    case 'GEEX_BABY_SITTER':
      return GeexBabySitterPageHeader
    case 'GEEX_BAR':
      return GeexBarPageHeader
    case 'GEEX_BARBER':
      return GeexBarberPageHeader
    case 'GEEX_BIRTHDAY':
      return GeexBirthdayPageHeader
    case 'GEEX_CHARITY':
      return GeexCharityPageHeader
    case 'GEEX_CHEF':
      return GeexChefPageHeader
    case 'GEEX_CLOTHING_STORE':
      return GeexClothingStorePageHeader
    case 'GEEX_CREATIVE_DESIGNER':
      return GeexCreativeDesignerPageHeader
    case 'GEEX_DAY_SPA':
      return GeexDaySpaPageHeader
    case 'GEEX_DJ':
      return GeexDjPageHeader
    case 'GEEX_DOCTOR':
      return GeexDoctorPageHeader
    case 'GEEX_DOG_WALKER':
      return GeexDogWalkerPageHeader
    case 'GEEX_ELECTRICIAN':
      return GeexElectricianPageHeader
    case 'GEEX_FASHION':
      return GeexFashionPageHeader
    case 'GEEX_FLORIST':
      return GeexFloristPageHeader
    case 'GEEX_FOUNDERS':
      return GeexFoundersPageHeader
    case 'GEEX_GAMER':
      return GeexGamerPageHeader
    case 'GEEX_GARDENER':
      return GeexGardenerPageHeader
    case 'GEEX_GROCERY':
      return GeexGroceryPageHeader
    case 'GEEX_GYM':
      return GeexGymPageHeader
    case 'GEEX_HAIR_STYLIST':
      return GeexHairStylistPageHeader
    case 'GEEX_HANDYMAN':
      return GeexHandymanPageHeader
    case 'GEEX_INTERIOR_DESIGNER':
      return GeexInteriorDesignerPageHeader
    case 'GEEX_MAKE_UP':
      return GeexMakeUpPageHeader
    case 'GEEX_MASSEUSE':
      return GeexMasseusePageHeader
    case 'GEEX_MEDITATION':
      return GeexMeditationPageHeader
    case 'GEEX_MUSIC_CONCERT':
      return GeexMusicConcertPageHeader
    case 'GEEX_MUSICIAN':
      return GeexMusicianPageHeader
    case 'GEEX_NAIL_SALON':
      return GeexNailSalonPageHeader
    case 'GEEX_PERSONAL_TRAINER':
      return GeexPersonalTrainerPageHeader
    case 'GEEX_PHOTOGRAPHER':
      return GeexPhotographerPageHeader
    case 'GEEX_REAL_ESTATE':
      return GeexRealEstatePageHeader
    case 'GEEX_RESTAURANT':
      return GeexRestaurantPageHeader
    case 'GEEX_RESUME':
      return GeexResumePageHeader
    case 'GEEX_SALES_MANAGER':
      return GeexSalesManagerPageHeader
    case 'GEEX_SOCIAL_MEDIA':
      return GeexSocialMediaPageHeader
    case 'GEEX_SPORTS_CLUB':
      return GeexSportsClubPageHeader
    case 'GEEX_TATTOO':
      return GeexTattooPageHeader
    case 'GEEX_TRAVEL_BLOGGER':
      return GeexTravelBloggerPageHeader
    case 'GEEX_TUTOR':
      return GeexTutorPageHeader
    case 'GEEX_WEB_DESIGNER':
      return GeexWebDesignerPageHeader
    case 'GEEX_WEDDING':
      return GeexWeddingPageHeader
    case 'GEEX_YOGA':
      return GeexYogaPageHeader
    case 'BASIC_1':
      return Basic1PageHeader
    case 'BASIC_2':
      return Basic2PageHeader
    case 'BASIC_3':
      return Basic3PageHeader
    case 'BASIC_4':
      return Basic4PageHeader
    default:
      return BasePageHeader
  }
}

function extractPosition(headerSlug: string): string {
  const match = /_(LEFT|CENTER|RIGHT)$/.exec(headerSlug || '')
  return match ? match[1].toLowerCase() : ''
}
